/**
 * Lightweight alternatives to Lodash functions
 * These utilities provide the same functionality with minimal bundle impact
 */

import { dequal } from 'dequal';

/**
 * Deep equality comparison - alternative to lodash/isEqual
 * Uses dequal library for robust deep equality checking
 * @param a - First value to compare
 * @param b - Second value to compare
 * @returns true if values are deeply equal
 */
export function isEqual(a: any, b: any): boolean {
  return dequal(a, b);
}

/**
 * Array difference - alternative to lodash/difference
 * @param array - The array to inspect
 * @param values - The values to exclude
 * @returns Returns the new array of filtered values
 */
export function difference<T>(array: T[], values: T[]): T[] {
  const valueSet = new Set(values);
  return array.filter((item) => !valueSet.has(item));
}
